import i18next from "i18next";
export const getFooterTranslation = () => {
  if (ClientContext.TenantName === "kpmg") {
    return i18next.t("kpmg-layout-footer");
  }
  if (ClientContext.TenantName === "mdc") {
    return i18next.t("mdc-layout-footer");
  }
  return i18next.t("taxdesk-layout-footer");
};
